import { render, staticRenderFns } from "./WelcomeBack.vue?vue&type=template&id=607adc50&scoped=true&"
import script from "./WelcomeBack.vue?vue&type=script&lang=js&"
export * from "./WelcomeBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607adc50",
  null
  
)

export default component.exports